<template>
  <q-icon
    :name="name"
    :size="size"
    class="tm-icon"
    :class="{
      [`tm-icon--rotate${rotate}`]: rotate,
      'tm-icon--mirror': mirror,
      'tm-icon--bold': bold,
      'tm-icon--disabled': disabled,
    }"
    :style="{
      color,
    }"
  />
</template>

<script lang="ts">
import type { WidgetIconName } from '@widgets/shared/icons/icons'
import { defineComponent, type PropType } from '@/composition/vue/compositionApi'
import type { StyleColors } from '@/constants/styleColors'

export type IconRotate = 0 | 45 | 90 | 180 | 295

export default defineComponent({
  props: {
    name: {
      type: String as PropType<WidgetIconName>,
    },
    rotate: {
      type: Number as PropType<IconRotate>,
    },
    mirror: {
      type: Boolean,
    },
    bold: {
      type: Boolean,
    },
    size: {
      type: String,
      default: '',
    },
    color: {
      type: String as PropType<StyleColors>,
    },
    disabled: {
      type: Boolean,
    },
  },
})
</script>

<style lang="scss" scoped>
.tm-icon {
  &--rotate45 {
    transform: rotate(45deg);
  }
  &--rotate90 {
    transform: rotate(90deg);
  }
  &--rotate180 {
    transform: rotate(180deg);
  }
  &--rotate295 {
    transform: rotate(295deg);
  }
  &--mirror {
    transform: scale(-1, 1);
  }
  &--bold {
    font-weight: $bold-font;
  }
  &--disabled {
    color: $gray5;
  }
}
// fix horizontal alignment
.tm-icon.tmi:before {
  display: inline !important;
}
</style>
